import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { redeemSessionToken } from "../services/apiService";
import analyticsService from "../services/analyticsService";
import StatusScreen from "./ui/StatusScreen";
import { GenericErrorScreen } from "./ErrorComponent";
import { setTokens } from "../services/tokenService";

// Canal A — reprise de session via le lien email : /sessions/:sessionToken/resume
// Au chargement, on échange le token opaque contre des tokens OAuth2 (ou un récap
// de session terminée), puis on bascule vers la page de suivi.
export default function SessionLinkComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { sessionToken } = useParams();
  const [error, setError] = useState(null); // null | "invalid" | "generic"
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const redeem = async () => {
      if (!sessionToken) {
        navigate("/error", {
          state: { errorText: t("resumeSession.errors.invalidLink") },
        });
        return;
      }

      analyticsService.pushPageView("session_link_redeem");

      try {
        const data = await redeemSessionToken(sessionToken);

        setTokens(data);

        analyticsService.pushEvent("session_link_redeem_success", {
          finished: Boolean(data.finishedTransaction),
        });

        navigate("/start-charging", {
          replace: true,
          state: {
            accessToken: data.accessToken,
            finishedTransaction: data.finishedTransaction || null,
          },
        });
      } catch (err) {
        analyticsService.pushEvent("session_link_redeem_failed", {
          status: err?.status,
        });
        setError(err?.status === 404 ? "invalid" : "generic");
      }
    };

    redeem();
  }, [sessionToken, navigate, t]);

  // Lien expiré ou déjà invalide : on renvoie vers la reprise par la borne.
  if (error === "invalid") {
    return (
      <StatusScreen
        icon="link-broken-linear"
        tone="warning"
        title={t("resumeSession.errors.invalidLink")}
        text={t("linkInvalid.text")}
      />
    );
  }

  if (error === "generic") {
    return <GenericErrorScreen text={t("resumeSession.errors.generic")} onRetry={() => window.location.reload()} />;
  }

  return <StatusScreen loading title={t("linkLoading.title")} text={t("linkLoading.text")} />;
}
